import { useFileManagerUI } from "@/components/core/FileManager";
import { useFileManagerMount } from "@/components/features/FileManager/FileManagerMount";
import { itemShareTarget } from "@/components/features/FileManager/shareTarget.utils";
import { ShareDialog } from "./ShareDialog";

export function ShareModal() {
  const { shareTarget, closeShare } = useFileManagerUI();
  const { mount } = useFileManagerMount();

  return (
    <ShareDialog
      target={shareTarget ? itemShareTarget(mount.type, shareTarget) : null}
      name={shareTarget?.name ?? ""}
      onClose={closeShare}
    />
  );
}
